import logging from '@/utils/logging'

/** sessionStorage-Key für den Zeitpunkt des letzten automatischen Reloads */
export const SESSIONSTORAGE_KEY_CHUNK_RELOAD = 'chunkLadefehlerReload'

/** Innerhalb dieses Zeitfensters kein zweiter Reload, sonst Reload-Schleife bei dauerhaft fehlendem Asset */
export const RELOAD_SPERRE_MS = 10_000

// Zeitpunkt des in dieser Seite angestoßenen Reloads; läuft ab, falls der Nutzer den Reload abbricht (beforeunload)
let reloadAngestossenUm = 0

/** Reload läuft – Folge-Events und Folgefehler bis zum Verlassen der Seite gehören noch zum Ladefehler */
export function istReloadAngestossen(): boolean {
  return Date.now() - reloadAngestossenUm < RELOAD_SPERRE_MS
}

/**
 * Nach einem Deploy fehlen die Chunks der alten Version (Hash im Dateinamen) – eine offene Seite lädt dann
 * beim nächsten Routenwechsel ins Leere. Einmal neu laden holt die aktuelle index.html. asix/organisation#14573
 */
export function reloadNachChunkLadefehler(event: Event): void {
  if (istReloadAngestossen()) {
    // Vite meldet pro Import jede fehlende CSS-Datei und den JS-Chunk einzeln
    event.preventDefault()
    return
  }
  try {
    const letzterReload = Number(sessionStorage.getItem(SESSIONSTORAGE_KEY_CHUNK_RELOAD)) || 0
    if (Date.now() - letzterReload < RELOAD_SPERRE_MS) {
      // Nicht unterdrücken, damit Sentry den Fehler sieht
      return
    }
    sessionStorage.setItem(SESSIONSTORAGE_KEY_CHUNK_RELOAD, String(Date.now()))
  } catch {
    // Ohne sessionStorage keine Sperre möglich – lieber kein Reload als eine Schleife
    return
  }
  reloadAngestossenUm = Date.now()
  event.preventDefault()
  logging.info('Chunk-Ladefehler, lade Seite neu')
  window.location.reload()
}

export function registriereChunkLadefehlerReload(): void {
  window.addEventListener('vite:preloadError', reloadNachChunkLadefehler)
}
